export default "__VITE_ASSET__BpEu_Htq__"